import Loadable from '../../components/loadable';

const UnverifiedEmailSenderWarningModal = Loadable({
  loader: () => import('../../pages/messages/unverified_email_sender_warning_modal'),
  type: 'modal',
});

angular
  .module('shared')
  .value('UnverifiedEmailSenderWarningModal', UnverifiedEmailSenderWarningModal);
